module.exports = __webpack_public_path__ + "static/media/HomeClientTrusted.46291b30.svg";